import x2 from './x2';
import x3 from './x3';
import x4 from './x4';
import x5 from './x5';
import x6 from './x6';
import x7 from './x7';
import x8 from './x8';
import x9 from './x9';
import x10 from './x10';
import x2x4 from './x2x4';
import x5x10 from './x5x10';
import x3x4 from './x3x4';
import x2x4x8 from './x2x4x8';
import x2x3x6 from './x2x3x6';
import x3x6x9 from './x3x6x9';

export default () => ({
  ...x2(),
  ...x3(),
  ...x4(),
  ...x5(),
  ...x6(),
  ...x7(),
  ...x8(),
  ...x9(),
  ...x10(),
  ...x2x4(),
  ...x5x10(),
  ...x3x4(),
  ...x2x4x8(),
  ...x2x3x6(),
  ...x3x6x9()
});
